import { C3Navigation } from "./c3-navigation";
import { withNotifications } from "./c3-notification-provider/c3-notification-provider";
export default withNotifications(C3Navigation);
